import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["presetInput", "presetButton", "fileInput"]

  selectPreset(event) {
    event.preventDefault()
    const selectedPreset = event.currentTarget.dataset.preset

    // Update hidden input
    this.presetInputTarget.value = selectedPreset

    // Clear file input if exists
    if (this.hasFileInputTarget) {
      this.fileInputTarget.value = ""
    }

    // Update all button styles
    this.presetButtonTargets.forEach(button => {
      const isSelected = button.dataset.preset === selectedPreset

      // Remove selected styles
      button.classList.remove("border-brand-500", "ring-2", "ring-brand-500")

      if (isSelected) {
        // Add selected styles
        button.classList.remove("border-gray-200", "dark:border-gray-700", "hover:border-gray-300", "dark:hover:border-gray-600")
        button.classList.add("border-brand-500", "ring-2", "ring-brand-500")
      } else {
        // Reset to default styles
        button.classList.add("border-gray-200", "dark:border-gray-700", "hover:border-gray-300", "dark:hover:border-gray-600")
      }
    })
  }

  clearPreset() {
    // Clear preset when custom file is selected
    this.presetInputTarget.value = ""

    // Reset all button styles to default
    this.presetButtonTargets.forEach(button => {
      button.classList.remove("border-brand-500", "ring-2", "ring-brand-500")
      button.classList.add("border-gray-200", "dark:border-gray-700", "hover:border-gray-300", "dark:hover:border-gray-600")
    })
  }
}
